import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import {CommonUtils} from "@utils/CommonUtils";
import routes from "./route-config";
import LoginPage from "./pages/login/LoginPage";
import React, {Suspense} from "react";
import {useAuthenticationContext} from "@utils/auth/AuthenticationContext";
import {usePiwikContext} from "@utils/tracking/PiwikContext";
import PreloaderComponent from "./components/layout/PreloaderComponent";
import useCommentSignalRConnection from "./utils/signalr/useCommentSignalRConnection";
import AppLayout from "@pages/AppLayout";
import ProtectedRoute from "@utils/auth/ProtectedRoute";
import NotFoundPage from "@pages/other/error_pages/NotFoundPage";
import PiwikPageTracker from "@utils/piwik_page_tracker/PiwikPageTracker";
import LogoutComponent from "@pages/login/LogoutComponent";
import AnnouncementsLoader from "@components/announcements/AnnouncementsLoader";


export default function AppRouter() {
    const {isInitialized} = useAuthenticationContext();
    const {utils, trackers} = usePiwikContext();

    utils.updateUserData();
    trackers.trackUserData();
    useCommentSignalRConnection();

    if (!isInitialized) return <PreloaderComponent/>;

    return (
        <BrowserRouter>
        <AnnouncementsLoader />
        <Suspense fallback={<PreloaderComponent/>}>
                <Routes>
                    {/* redirect root → /en */}
                    <Route path="/" element={
                        <>
                            <PiwikPageTracker/>
                            <Navigate to="/en" replace/>
                        </>
                    }/>

                    <Route path="/logout" element={<LogoutComponent/>}/>
                    <Route path="/:lng/logout" element={<LogoutComponent/>}/>

                    {/* no-lang login */}
                    <Route path="/login" element={<LoginPage/>}/>

                    {/* lang-prefixed login */}
                    <Route path="/:lng/login" element={<LoginPage/>}/>

                    {/* lang-free dashboard shortcut */}
                    <Route path="/dashboard" element={<Navigate to={`/${CommonUtils.getLng()}/dashboard`} replace/>}/>

                    {/* callback */}
                    {/*<Route path="/auth-callback" element={<AuthCallbackComponent />} />*/}
                    <Route path="/auth-callback" element={<LoginPage/>}/>

                    {/* everything else under /:lng */}
                    <Route path="/:lng" element={<AppLayout/>}>
                        {routes.map(route => {
                            const subPath = route.path.replace("/:lng/", "") || "";
                            return (
                                <Route
                                    key={route.path}
                                    path={subPath}
                                    element={
                                        <ProtectedRoute
                                            element={
                                                <>
                                                    <PiwikPageTracker/>
                                                    {route.element}
                                                </>
                                            }
                                            roleMask={route.roleMask}
                                            labFilter={route.labFilter}
                                            divisionFilter={route.divisionFilter}
                                        />
                                    }
                                />
                            );
                        })}
                        <Route path="*" element={<NotFoundPage/>}/>
                    </Route>

                    {/* top-level unmatched paths — redirect to localised 404 */}
                    <Route path="*" element={<Navigate to={`/${CommonUtils.getLng()}/unknown`} replace/>}/>
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
}
